/**
 * @generated SignedSource<<f0047bbb2a2116c264494084ff687de7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserMetadata_user$data = {
  readonly bio: string | null | undefined;
  readonly firstName: string;
  readonly lastName: string;
  readonly primaryPhoto: {
    readonly seoUrl: string;
  } | null | undefined;
  readonly slugId: string;
  readonly " $fragmentType": "UserMetadata_user";
};
export type UserMetadata_user$key = {
  readonly " $data"?: UserMetadata_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserMetadata_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserMetadata_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": "seoUrl",
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 1,
                "fit": "cover",
                "h": 630,
                "w": 1200
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":630,\"w\":1200})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e64823592f7c045563f08d228188f1a7";

export default node;
